import { inject, Injectable } from "@angular/core";
import { MtSuccessState } from "@modules/margin-trading/+states/mt-success.state";
import { AcceptMarginOfferMutation } from "../../../../api/graphql/offer/generated/margin-trading.offer.accept.service.graphql-gen";
import { Tradable } from "@models/interfaces/tradable";
import { Fiat } from "@models";
import { Observable } from "rxjs";
import { IMTOrderButtonVisibility, MarginTradingFacade } from "@modules/margin-trading/services/margin-trading.facade";
import { AssetFragment } from "../../../../api/graphql/bff/generated/fragments.service.graphql-gen";

@Injectable({
	providedIn: "root"
})
export class MtSuccessFacade {
	private readonly mtSuccessState = inject(MtSuccessState);
	private readonly mtFacade = inject(MarginTradingFacade);

	public getViewModel$ = this.mtSuccessState.viewModel$;

	public setViewModel(
		acceptedMarginOffer: AcceptMarginOfferMutation["acceptMarginOffer"],
		fiat: Fiat,
		tradable: Tradable,
		assetInfo: AssetFragment
	): void {
		this.mtSuccessState.setVm(acceptedMarginOffer, fiat, tradable, assetInfo);
	}

	mtSellLimitOrderEnabled$(isEnabled: boolean): Observable<IMTOrderButtonVisibility> {
		return this.mtFacade.marginTradingOrderButtonVisibilityHelper(isEnabled);
	}
}
